import { render, staticRenderFns } from "./ItemListAuctionHistoryLayout.vue?vue&type=template&id=452a8b7e&scoped=true"
import script from "./ItemListAuctionHistoryLayout.vue?vue&type=script&lang=js"
export * from "./ItemListAuctionHistoryLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452a8b7e",
  null
  
)

export default component.exports